module.exports = __webpack_public_path__ + "img/4255632_orig.14730896.png";